import PropTypes from "prop-types";
import { useEffect } from "react";

import styled from "styled-components/macro";

import { useCellMeasurements } from "Boards";

import { colors } from "UI/colors";

import { formatNumberWithCommas } from "Utilities/Number";

TotalCell.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export function TotalCell({ data }) {
  const getRoundedValue = () => {
    return Math.round((Number(data.number) + Number.EPSILON) * 100) / 100;
  };

  const { MeasureCell, remeasureCell } = useCellMeasurements({
    columnID: "totals",
  });

  useEffect(() => {
    remeasureCell();
  }, [data?.check, data?.number]);

  const cellContent = () => (
    <Wrapper>
      {data?.check ? (
        <Item>
          <span className="fas fa-check-circle" />{" "}
          {formatNumberWithCommas(data.check)}
        </Item>
      ) : null}
      {data?.number ? (
        <Item style={{ marginLeft: "5px" }}>
          <span className="far fa-plus-square" />{" "}
          {formatNumberWithCommas(getRoundedValue())}
        </Item>
      ) : null}
    </Wrapper>
  );

  return (
    <>
      {cellContent()}
      <MeasureCell>
        <MeasureStyling>{cellContent()}</MeasureStyling>
      </MeasureCell>
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  padding-left: 5px;
  box-sizing: border-box;
`;

const Item = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${colors.fnDkBlue};
  white-space: nowrap;
`;
const MeasureStyling = styled.div`
  padding: 0 5px;
`;
